import {Component, Input, OnInit} from '@angular/core';
import {Discount, DiscountBenefit, Cart, DiscountEntry, DiscountType} from "../../../../common";

@Component({
  selector: 'discount-entry',
  standalone: false,
  styles: [`
    discount-benefit {
      color: #28a745;
      font-style: italic;
      text-align: right;
    }
    :host-context(.list-group-item.active) discount-benefit {
      color: #fff !important;
    }
  `],
  template: `
    <div class="row">
      <div [ngClass]="{'col-11': reallyShowSelection, 'col-12': !reallyShowSelection}">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="flex-grow-1" *ngIf="discount.type == DiscountType.General">{{discount.title}}</div>
          <div class="flex-grow-1" *ngIf="discount.type == DiscountType.Code">
            <span i18n>Discount Code</span><br>
            <samp>{{discount.code}}</samp>
          </div>
          <ng-content></ng-content>
          <div *ngIf="entry.amount">- {{ entry.amount|currency:cart.host }}</div>
          <discount-benefit class="flex-grow-1"
                            *ngFor="let benefit of benefits"
                            [cart]="cart" [benefit]="benefit" [index]="entry.index"
                            [pastTense]="pastTense"></discount-benefit>
        </div>
      </div>
      <div class="col-1 pl-0 pr-0 text-center" *ngIf="reallyShowSelection">
        <i class="fas fa-pencil-alt"></i>
      </div>
    </div>
  `
})

export class DiscountEntryComponent implements OnInit {
  @Input() entry: DiscountEntry;
  @Input() pastTense: boolean = false;
  @Input() showSelection: boolean = false;
  DiscountType = DiscountType;
  cart: Cart;
  discount: Discount;
  benefits: Array<DiscountBenefit>;
  reallyShowSelection: boolean;

  ngOnInit(): void {
    this.cart = this.entry.cart;
    this.discount = this.entry.discount;
    this.benefits = this.entry.discount.benefits.filter(b=>!b.hasAmount());
    this.reallyShowSelection = this.showSelection && this.discount.needsSelection();
  }

}
